import { render, staticRenderFns } from "./LaboratoryIndex.vue?vue&type=template&id=9030e680"
import script from "./LaboratoryIndex.vue?vue&type=script&lang=js"
export * from "./LaboratoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports